import ReportLoader from 'features/assistance/';
import ReportWizard from 'features/assistance/as-instructor';
import React from 'react';

const AssistancePage = () => {
  return <ReportLoader ReportWizard={ReportWizard} />;
};

export default AssistancePage;
